<div class="auth-page">
  <div class="auth-card text-center" style="max-width: 600px;">
    <div class="flex align-items-center justify-content-center mb-4">
      <img src="assets/images/logo/logo-main.png" alt="" class="auth-logo" />
    </div>
    <ng-container *ngIf="status === 'loading'">
      <p>Vérification de votre compte...</p>
      <div class="loader"></div>
    </ng-container>

    <ng-container *ngIf="status === 'success'">
      <h2>Compte vérifié avec succès</h2>
      <p>Vous pouvez maintenant vous connecter.</p>
    </ng-container>

    <ng-container *ngIf="status === 'error'">
      <h2>Vérification échouée</h2>
      <p>Le lien est invalide ou expiré.</p>
    </ng-container>
  </div>
</div>
